import { render } from "./ConsultaDadosRecentes.vue?vue&type=template&id=9cf14c34&scoped=true"
import script from "./ConsultaDadosRecentes.vue?vue&type=script&lang=js"
export * from "./ConsultaDadosRecentes.vue?vue&type=script&lang=js"

import "./ConsultaDadosRecentes.vue?vue&type=style&index=0&id=9cf14c34&scoped=true&lang=css"

import exportComponent from "/opt/vue/ped/ped-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf14c34"]])

export default __exports__